import { isArray } from 'lodash';
import { parse, parseUrl as originParseUrl } from 'query-string';
/**
 * クエリ文字列をオブジェクトにパースする
 */
export const parseQuery = (query) => parse(query);
/**
 * クエリ文字列をオブジェクトにパースする
 */
export const parseUrl = (url) => originParseUrl(url, { parseFragmentIdentifier: true });
/**
 * クエリ文字列をオブジェクトにパースしたものを文字列として返す
 */
export const parsedQueryToString = (parsedQueryValue) => {
    if (!parsedQueryValue) {
        return '';
    }
    if (Array.isArray(parsedQueryValue)) {
        return parsedQueryValue[0];
    }
    return parsedQueryValue;
};
/**
 * クエリ文字列をオブジェクトにパースする(文字列で受け取る)
 */
export const getParsedQueryString = (queryValue, arrayIndex) => {
    if (!queryValue) {
        return '';
    }
    return isArray(queryValue) ? queryValue[arrayIndex || 0] : queryValue;
};
